import React from "react";
import Grid from "@mui/material/Grid";
import Title from "/app/components/LandingPage/Title";
import useStyles from "/app/components/LandingPage/landingStyle-jss";
import "./resources.css";

const Resources = (props) => {
  const { slideMode } = props;
  const { classes, cx } = useStyles();
  return (
    <div className="py-5 section-resources">
      <div className={slideMode ? classes.fullWidth : classes.container}>
        <Title
          title="Resources"
          // desc="Integrated all your services at one platform"
          align="center"
        />
        <Grid container spacing={2} className="mt--3">
          <Grid item md={3} xs={12} className="text-center">
            <div className="card-resources card-resources-1">
              <i className="fa-solid fa-user"></i>
              <h5 className="card-resources-title">Cyber Nagrik</h5>
              {/* <p className="card-resources-text">Some description here</p> */}
              {/* <div className="btn-holder">
              <a className="btn btn-outline-primary" href="#" title="">
                Button Text
              </a>
            </div> */}
            </div>
          </Grid>
          <Grid item md={3} xs={12} className="text-center">
            <div className="card-resources card-resources-2">
              <i className="fa-solid fa-user"></i>
              <h5 className="card-resources-title">CISO</h5>
              {/* <p className="card-resources-text">Some description here</p> */}
              {/* <div className="btn-holder">
              <a className="btn btn-outline-primary" href="#" title="">
                Button Text
              </a>
            </div> */}
            </div>
          </Grid>
          <Grid item md={3} xs={12} className="text-center">
            <div className="card-resources card-resources-3">
              <i className="fa-solid fa-user"></i>
              <h5 className="card-resources-title">Ideation & Innovation</h5>
              {/* <p className="card-resources-text">Some description here</p> */}
              {/* <div className="btn-holder">
              <a className="btn btn-outline-primary" href="#" title="">
                Button Text
              </a>
            </div> */}
            </div>
          </Grid>
          <Grid item md={3} xs={12} className="text-center">
            <div className="card-resources card-resources-4">
              <i className="fa-solid fa-user"></i>
              <h5 className="card-resources-title">Cyberkid</h5>
              {/* <p className="card-resources-text">Some description here</p> */}
              {/* <div className="btn-holder">
              <a className="btn btn-outline-primary" href="#" title="">
                Button Text
              </a>
            </div> */}
            </div>
          </Grid>
        </Grid>
      </div>
    </div>
  );
};

export default Resources;
